import React from 'react';
import { JUST_ONE_PAGE_LOGO, JUST_ONE_PAGE_NAME } from '../justOnePageBrand';

const SIZE_CLASS = {
  xs: 'h-7',
  sm: 'h-9',
  md: 'h-12',
  lg: 'h-16',
  xl: 'h-24',
};

export default function JustOnePageLogo({ size = 'md', className = '' }) {
  return (
    <img
      src={JUST_ONE_PAGE_LOGO}
      alt={JUST_ONE_PAGE_NAME}
      className={`w-auto object-contain ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`.trim()}
      draggable={false}
    />
  );
}
